import { Component, OnInit } from '@angular/core';
import { ShoppingCart } from 'src/app/classes';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { Guid } from 'src/app/globals';
import { SessionService } from 'src/app/lib/shared/services/session.service';
import { RootService } from 'src/app/services/root.service';

@Component({
  selector: 'app-shop-standalone',
  templateUrl: './shop-standalone.component.html',
  styleUrls: ['./shop-standalone.component.css']
})
export class ShopStandaloneComponent implements OnInit {

  _cart: ShoppingCart;
  set cart(cart: ShoppingCart){
    this._cart = cart;
  }
  get cart(): ShoppingCart {
    return this._cart;
  }

  callbackURL: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _dataService: DataService,
    private _rootService: RootService
  ) {
    this._rootService.hideNavbar();
    this._route.params.subscribe((params) => {
      var cartId = params["id"];
      let cart: ShoppingCart = this._dataService.shoppingCarts.find(x => x.guid == cartId);
      if(cart) this.cart = cart;
    });
    this._route.queryParams.subscribe((params) => {
      this.callbackURL = params["callbackURL"];
      if(this.callbackURL) console.log(this.callbackURL);
    });
  }

  confirmOrder(){
    console.log(this.cart);
    if(this.callbackURL){
      this._router.navigate([this.callbackURL], {
        queryParams: {
          "shoppingCart": this.cart.guid
        }
      })
    }
  }

  createShoppingCart(){
    let cart = new ShoppingCart();
    cart.guid = Guid.newGuid();
    cart.products = [];
    this._dataService.addShoppingCart(cart);
    this.cart = cart;
  }

  ngOnInit(): void {
    
  }

}
